var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClaimMeLogo = function SvgClaimMeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7940_42480)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22266 1.77156C1.22266 1.34367 1.5743 0.992188 2.0024 0.992188H3.56188C3.98998 0.992188 4.34162 1.34367 4.34162 1.77156V4.10967H2.0024C1.5743 4.10967 1.22266 3.75819 1.22266 3.3303V1.77156Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3586 10.7109H21.3433C15.4664 10.7109 10.7021 15.4729 10.7021 21.347V21.3623C10.7021 27.2365 15.4664 31.9984 21.3433 31.9984H21.3586C27.2356 31.9984 31.9998 27.2365 31.9998 21.3623V21.347C31.9998 15.4729 27.2356 10.7109 21.3586 10.7109Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39369 8.22159V4.11079H5.15241C4.72432 4.11079 4.38796 4.44699 4.38796 4.87488V8.22159H8.39369ZM12.5982 4.11079V7.4575C12.5982 7.88539 12.2618 8.22159 11.8337 8.22159H8.39369V11.3696C8.39369 11.7975 8.05733 12.1337 7.62924 12.1337H4.38796V8.22159H1.5442C1.1161 8.22159 0.779742 8.55779 0.779742 8.98567V11.3696C0.779742 11.7975 1.1161 12.1337 1.5442 12.1337H4.38796V15.0678C4.38796 15.4957 4.0516 15.8319 3.62351 15.8319H0.764453C0.336359 15.8319 0 16.1681 0 16.596V19.2092C0 20.447 1.00908 21.4403 2.24749 21.4403H19.2031C20.4415 21.4403 21.4506 20.4317 21.4506 19.1939V2.24642C21.4506 1.0086 20.4415 0 19.2031 0H17.3684C16.9556 0 16.6039 0.336199 16.6039 0.764088V3.34671C16.6039 3.77459 16.2676 4.11079 15.8395 4.11079H12.5982ZM9.15815 0.0152818C8.74534 0.0152818 8.39369 0.35148 8.39369 0.77937V4.12607H12.5982V0.77937C12.5982 0.35148 12.2618 0.0152818 11.8337 0.0152818H9.15815Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3586 10.7109H21.3433C15.4664 10.7109 10.7021 15.4729 10.7021 21.347V21.3623C10.7021 27.2365 15.4664 31.9984 21.3433 31.9984H21.3586C27.2356 31.9984 31.9998 27.2365 31.9998 21.3623V21.347C31.9998 15.4729 27.2356 10.7109 21.3586 10.7109Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7940_42480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 22,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3586 10.7109H21.3433C15.4664 10.7109 10.7021 15.4729 10.7021 21.347V21.3623C10.7021 27.2365 15.4664 31.9984 21.3433 31.9984H21.3586C27.2356 31.9984 31.9998 27.2365 31.9998 21.3623V21.347C31.9998 15.4729 27.2356 10.7109 21.3586 10.7109Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7940_42480)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39369 8.22159V4.11079H5.15241C4.72432 4.11079 4.38796 4.44699 4.38796 4.87488V8.22159H8.39369ZM12.5982 4.11079V7.4575C12.5982 7.88539 12.2618 8.22159 11.8337 8.22159H8.39369V11.3696C8.39369 11.7975 8.05733 12.1337 7.62924 12.1337H4.38796V8.22159H1.5442C1.1161 8.22159 0.779742 8.55779 0.779742 8.98567V11.3696C0.779742 11.7975 1.1161 12.1337 1.5442 12.1337H4.38796V15.0678C4.38796 15.4957 4.0516 15.8319 3.62351 15.8319H0.764453C0.336359 15.8319 0 16.1681 0 16.596V19.2092C0 20.447 1.00908 21.4403 2.24749 21.4403H19.2031C20.4415 21.4403 21.4506 20.4317 21.4506 19.1939V2.24642C21.4506 1.0086 20.4415 0 19.2031 0H17.3684C16.9556 0 16.6039 0.336199 16.6039 0.764088V3.34671C16.6039 3.77459 16.2676 4.11079 15.8395 4.11079H12.5982ZM9.15815 0.0152818C8.74534 0.0152818 8.39369 0.35148 8.39369 0.77937V4.12607H12.5982V0.77937C12.5982 0.35148 12.2618 0.0152818 11.8337 0.0152818H9.15815Z",
    fill: "white"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22266 1.77156C1.22266 1.34367 1.5743 0.992188 2.0024 0.992188H3.56188C3.98998 0.992188 4.34162 1.34367 4.34162 1.77156V4.10967H2.0024C1.5743 4.10967 1.22266 3.75819 1.22266 3.3303V1.77156Z",
    fill: "#582BFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3586 10.7109H21.3433C15.4664 10.7109 10.7021 15.4729 10.7021 21.347V21.3623C10.7021 27.2365 15.4664 31.9984 21.3433 31.9984H21.3586C27.2356 31.9984 31.9998 27.2365 31.9998 21.3623V21.347C31.9998 15.4729 27.2356 10.7109 21.3586 10.7109Z",
    fill: "url(#paint0_linear_7940_42480)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16777 4.10938C4.73968 4.10938 4.40332 4.44557 4.40332 4.87346V8.22017H8.40905V4.10938H5.16777Z",
    fill: "url(#paint1_linear_7940_42480)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 8.21875C1.11566 8.21875 0.779297 8.55495 0.779297 8.98284V11.3668C0.779297 11.7947 1.11566 12.1309 1.54375 12.1309H4.38751V8.21875H1.54375Z",
    fill: "url(#paint2_linear_7940_42480)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8492 0.015625H9.17363C8.76083 0.015625 8.40918 0.351824 8.40918 0.779713V4.12642H12.6137V0.779713C12.6137 0.351824 12.2773 0.015625 11.8492 0.015625Z",
    fill: "url(#paint3_linear_7940_42480)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7023 21.3486C10.7023 15.4651 15.4725 10.7125 21.3435 10.7125H21.4353V2.24642C21.4353 1.0086 20.4262 0 19.1878 0H17.3531C16.9403 0 16.5886 0.336199 16.5886 0.764088V3.3467C16.5886 3.77459 16.2523 4.11079 15.8242 4.11079H12.5829V7.4575C12.5829 7.88539 12.2465 8.22159 11.8184 8.22159H8.3784V11.3696C8.3784 11.7975 8.04204 12.1337 7.61395 12.1337H4.37267V15.0678C4.37267 15.4957 4.03631 15.8319 3.60822 15.8319H0.764453C0.336359 15.8319 0 16.1681 0 16.596V19.2092C0 20.447 1.00908 21.4556 2.24749 21.4556H10.7023V21.3486Z",
    fill: "url(#paint4_linear_7940_42480)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4507 10.7106H21.359C15.4727 10.7106 10.7178 15.4785 10.7178 21.3467V21.4384H19.2185C20.4569 21.4384 21.466 20.4298 21.466 19.192V10.6953L21.4507 10.7106Z",
    fill: "url(#paint5_linear_7940_42480)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7940_42480",
    x1: 21.351,
    y1: 31.9984,
    x2: 21.351,
    y2: 10.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7940_42480",
    x1: 16.4557,
    y1: -3.66445,
    x2: -3.6551,
    y2: 16.4712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B36FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7940_42480",
    x1: 16.5591,
    y1: -3.56196,
    x2: -3.56695,
    y2: 16.5584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B36FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7940_42480",
    x1: 16.4619,
    y1: -3.65658,
    x2: -3.64886,
    y2: 16.4791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B36FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7940_42480",
    x1: 22.1707,
    y1: 2.05387,
    x2: 2.04917,
    y2: 22.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B36FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7940_42480",
    x1: 14.4926,
    y1: 12.9494,
    x2: 18.5106,
    y2: 20.7905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7940_42480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
export default SvgClaimMeLogo;